import { GlobalStateContext } from 'piral-core';

import { firefliesStorageKey } from './constants';
import { FirefliesLevels, FirefliesSettings } from './types';

const defaultSettings: FirefliesSettings = {
  count: 0,
  color: '#ffbb44',
  glowColor: '#ff9933',
  minSize: 2,
  maxSize: 5,
  speed: 1,
};

export function setFirefliesLevel(ctx: GlobalStateContext, level: FirefliesLevels) {
  ctx.dispatch(state => {
    const levelNum = Number(level);
    const newSettings: FirefliesSettings | null =
      levelNum === 0
        ? null
        : {
            ...defaultSettings,
            count: levelNum * levelNum * 8, // Level 1 = 8, Level 2 = 32, Level 3 = 72, Level 4 = 128, Level 5 = 200
          };

    if (newSettings) {
      localStorage.setItem(firefliesStorageKey, JSON.stringify(newSettings));
    } else {
      localStorage.removeItem(firefliesStorageKey);
    }

    return {
      ...state,
      firefliesSettings: newSettings,
    };
  });
}
